import * as Service from '@/App/Service';
import ChalkySticks from '@chalkysticks/sdk';
import Store from '@/Store';

/**
 * Whether notifications manager has been initialized
 *
 * @type boolean
 */
let hasInitialized: boolean = false;

/**
 * Initialize push notification coordination.
 *
 * @return Promise<void>
 */
export async function initialize(): Promise<void> {
	if (hasInitialized) {
		return;
	}

	// Listen for onboarding completion to trigger native prompt
	ChalkySticks.Core.Event.Bus.on('onboarding:completed', async () => {
		await Service.PushNotification.register();
	});

	// If onboarding already complete, register now
	if (Store.getters['settings/onboardingComplete']) {
		await Service.PushNotification.register();
	}

	hasInitialized = true;
}
